export const getPermissions = user => {
  if (!user || !user?.currentSeller || !user?.sellerPermissions) {
    return {}
  }

  const currentSellerTenantId = user.currentSeller?.tenantId
  const currentPermissions = user.sellerPermissions[currentSellerTenantId] ?? {}
  const currentPermissionsForProducts = currentPermissions['product-api'] ?? []
  return currentPermissionsForProducts
}
